import axios from "axios";
import { API_BASE_URL } from "../utils/config";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { firestore } from "../../services/firebase";

// Create a new accessory type
const createAccessoryType = async (user, accessoryTypeData) => {
  try {
    if (user) {
      const idTokenResult = await user.getIdTokenResult();
      if (
        idTokenResult.claims.admin === true ||
        idTokenResult.claims.subAdmin === true
      ) {
        const idToken = await user.getIdToken();
        const response = await axios.post(
          `${API_BASE_URL}api/accessoryTypes/accessoryTypes`,
          accessoryTypeData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${idToken}`,
            },
          }
        );
        return response;
      } else {
        throw {
          response: {
            data: {
              message: "User is not authorized to create accessory types.",
              type: "error",
            },
          },
        };
      }
    }
  } catch (error) {
    throw error;
  }
};

// Update an accessory type
const updateAccessoryType = async (
  user,
  accessoryTypeId,
  accessoryTypeData
) => {
  try {
    if (!user) {
      return null;
    }

    const idTokenResult = await user.getIdTokenResult();
    if (
      idTokenResult.claims.admin === true ||
      idTokenResult.claims.subAdmin === true
    ) {
      const idToken = await user.getIdToken();
      const response = await axios.put(
        `${API_BASE_URL}api/accessoryTypes/accessoryTypes/${accessoryTypeId}`,
        accessoryTypeData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${idToken}`,
          },
        }
      );
      return response;
    } else {
      throw {
        response: {
          data: {
            message: "User is not authorized to update accessory types.",
            type: "error",
          },
        },
      };
    }
  } catch (error) {
    throw error;
  }
};

// Delete an accessory type
const deleteAccessoryType = async (user, accessoryTypeId) => {
  try {
    if (!user) {
      return null;
    }

    const idTokenResult = await user.getIdTokenResult();
    if (
      idTokenResult.claims.admin === true ||
      idTokenResult.claims.subAdmin === true
    ) {
      const idToken = await user.getIdToken();
      const response = await axios.delete(
        `${API_BASE_URL}api/accessoryTypes/accessoryTypes/${accessoryTypeId}`,
        {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        }
      );
      return response;
    } else {
      throw {
        response: {
          data: {
            message: "User is not authorized to delete accessory types.",
            type: "error",
          },
        },
      };
    }
  } catch (error) {
    throw error;
  }
};

// Get accessory types for a specific branch (read operation - can be done directly from Firestore)
const getAccessoryTypes = (branchId, setData) => {
  const accessoryTypesCollection = collection(firestore, "AccessoryTypes");
  const q = query(accessoryTypesCollection, where("branchId", "==", branchId));

  return onSnapshot(q, (querySnapshot) => {
    const accessoryTypes = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setData(accessoryTypes);
  });
};

export {
  createAccessoryType,
  updateAccessoryType,
  deleteAccessoryType,
  getAccessoryTypes,
};
